module.exports = __webpack_public_path__ + "img/logo.b913e470.png";